import script from "./Badge.vue?vue&type=script&setup=true&lang=js"
export * from "./Badge.vue?vue&type=script&setup=true&lang=js"

import "./Badge.vue?vue&type=style&index=0&id=2db4a1a5&lang=css"

const __exports__ = script;

export default __exports__